import {} from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useGridStyles = makeStyles((theme) => ({
	root: {
		"& .ag-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			fontSize: 12,
			lineBreak: "auto",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			border: "0 !important",
			wordBreak: "break-word",
		},

		"& .ag-icon-menu": {
			display: "none",
		},
		"& .ag-header-group-text ": {
			fontSize: 11,
		},
		"& .ag-root-wrapper": {
			borderRadius: 3,
		},
		"& .ag-header-cell": {
			padding: 2,
		},
		"& .ag-header-cell-label": {
			justifyContent: "center",
			fontSize: "1.5vh",
		},
		"& .ag-center-aligned-header": {
			textAlign: "center !important",
		},
		"& .ag-center-aligned-cell": {
			textAlign: "center !important",
		},
		"& .ag-button-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			cursor: "pointer",
		},
		"& .info-limit": {
			color: "#000",
			backgroundColor: "#b2e5ed",
			fontWeight: 600,
		},
		"& .eaf-11": {
			fontWeight: 500,
			"& .MuiChip-outlined": {
				backgroundColor: " #dae8fc",
			},
		},
		"& .eaf-12": {
			fontWeight: 500,
			"& .MuiChip-outlined": {
				backgroundColor: "#d5e8d4",
			},
		},
		"& .warning-limit": {
			color: "#CC0000",
			fontWeight: 800,
		},
	},
	buttons: {
		opacity: 0,
		transition: "opacity 0.1s ease-in-out",
		display: "flex",
		width: "100%",
		justifyContent: "space-around",
		".ag-row-hover &": {
			opacity: 1,
		},
	},
	btnModal: {
		display: "flex",
		justifyContent: "flex-end",
	},
}));
